<template>
  <div class="footer">
    <footer class="footer-distributed">
      <div class="footer-left">
        <div class="logoContainer">
          <img class="footerCompanyLogo" src="images/small_logo.png" />
          <span class="ibcText">
            <p>International Business Center</p>
            <p>Since 1986</p>
          </span>
        </div>
        <p class="footer-company-name">{{ $t("footer.copyright[0]") }}</p>

        <p class="footer-company-name">{{ $t("footer.copyright[1]") }}</p>
      </div>

      <div class="footer-center">
        <p class="footer-links">
          <router-link to="/">{{ $t("footer.home") }}</router-link
          >·
          <router-link to="/introduction">{{
            $t("footer.introduction")
          }}</router-link
          >·
          <router-link to="/servicedoffice">{{
            $t("footer.servicedoffice")
          }}</router-link
          >·
          <router-link to="/virtualoffice">{{
            $t("footer.virtualoffice")
          }}</router-link
          >·
          <router-link to="/professionalservices">{{
            $t("footer.professionalservices")
          }}</router-link
          >·
          <router-link to="/contactus">{{
            $t("footer.contactus")
          }}</router-link>
        </p>
      </div>

      <div class="footer-right">
        <div>
          <font-awesome-icon
            :icon="['fas', 'map-marker-alt']"
            size="lg"
            :style="{ color: 'white' }"
            fixed-width
          />
          <p class="marginLeft">
            <span>{{ $t("footer.address") }}</span>
          </p>
        </div>

        <div>
          <font-awesome-icon
            :icon="['fas', 'phone']"
            size="lg"
            :style="{ color: 'white' }"
            fixed-width
          />
          <p class="marginLeft">+852 2268 6888</p>
        </div>

        <div>
          <font-awesome-icon
            :icon="['fas', 'fax']"
            size="lg"
            :style="{ color: 'white' }"
            fixed-width
          />
          <p class="marginLeft">+852 2721 3881</p>
        </div>

        <div>
          <font-awesome-icon
            :icon="['fas', 'envelope']"
            size="lg"
            :style="{ color: 'white' }"
            fixed-width
          />
          <p class="marginLeft">
            <a
              href="mailto:info@ibchk.com?subject=Enquiry to International Business Center"
              >info@ibchk.com</a
            >
          </p>
        </div>

        <div class="socialMedia">
          <a
            href="https://www.facebook.com/IBC-International-Business-Center-135981363113836/"
            target="_blank"
            class="socialMediaItem"
          >
            <font-awesome-icon
              :icon="['fab', 'facebook-square']"
              size="2x"
              :style="{ color: 'white' }"
              fixed-width
            />
          </a>

          <a
            href="https://www.instagram.com/ibc_hk/"
            target="_blank"
            class="socialMediaItem"
          >
            <font-awesome-icon
              :icon="['fab', 'instagram']"
              size="2x"
              :style="{ color: 'white' }"
              fixed-width
            />
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.ibcText {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
}

.ibcText p {
  margin: 0;
}

.footer-distributed {
  background-color: #292c2f;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  width: 100%;
  text-align: left;
  font: bold 16px sans-serif;
  padding: 55px 50px;
}

.footer-distributed .footer-left,
.footer-distributed .footer-center,
.footer-distributed .footer-right {
  display: inline-block;
  vertical-align: top;
}

.footer-distributed .footer-left {
  width: 30%;
}

.footer-distributed h3 {
  color: #ffffff;
  margin: 0;
}

.footer-distributed h3 span {
  color: #5383d3;
}

.footer-distributed .footer-links {
  color: #ffffff;
  margin: 20px 0 12px;
  padding: 0;
}

.footer-distributed .footer-links a {
  display: inline-block;
  line-height: 1.8;
  text-decoration: none;
  color: inherit;
}

.footer-distributed .footer-company-name {
  color: #8f9296;
  font-size: 14px;
  font-weight: normal;
  margin: 0;
}

.footer-distributed .footer-center {
  width: 35%;
}

.footer-distributed .footer-center i {
  background-color: #33383b;
  color: #ffffff;
  font-size: 25px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  text-align: center;
  line-height: 42px;
  margin: 10px 15px;
  vertical-align: middle;
}

.footer-distributed .footer-center i.fa-envelope {
  font-size: 17px;
  line-height: 38px;
}

.footer-distributed .footer-center p {
  display: inline-block;
  color: #ffffff;
  vertical-align: middle;
  margin: 0;
}

.footer-distributed .footer-center p span {
  display: block;
  font-weight: normal;
  font-size: 14px;
  line-height: 2;
}

.footer-distributed .footer-center p a {
  color: #5383d3;
  text-decoration: none;
}

.footer-distributed .footer-right {
  width: 35%;
}

.footer-distributed .footer-company-about {
  line-height: 20px;
  color: #92999f;
  font-size: 13px;
  font-weight: normal;
  margin: 0;
}

.footer-distributed .footer-company-about span {
  display: block;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 20px;
}

.footer-distributed .footer-icons {
  margin-top: 25px;
}

.footer-distributed .footer-icons a {
  display: inline-block;
  width: 35px;
  height: 35px;
  cursor: pointer;
  background-color: #33383b;
  border-radius: 2px;

  font-size: 20px;
  color: #ffffff;
  text-align: center;
  line-height: 35px;

  margin-right: 3px;
  margin-bottom: 5px;
}

@media (max-width: 880px) {
  .footer-distributed {
    font: bold 14px sans-serif;
  }

  .footer-distributed .footer-left,
  .footer-distributed .footer-center,
  .footer-distributed .footer-right {
    display: block;
    width: 100%;
    margin-bottom: 40px;
    text-align: center;
  }

  .footer-distributed .footer-center i {
    margin-left: 0;
  }
  .main {
    line-height: normal;
    font-size: auto;
  }
}

.footer-right {
  color: white;
}

.footer-right > div {
  display: flex;
}

.footer-links.second {
  margin-top: 1rem !important;
}

a {
  color: white !important;
  text-decoration: none !important;
}

a:hover {
  color: #007bff !important;
  text-decoration: none !important;
}

.logoContainer {
  width: 100%;
  height: 100%;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.logoContainer > img {
  width: 15%;
  height: 100%;
  object-fit: contain;
}

.marginLeft {
  margin-left: 0.5rem;
}

.socialMediaItem > svg:hover {
  color: #007bff !important;
}

.socialMediaItem {
  margin-left: 0.85rem;
  margin-right: 0.85rem;
}

.socialMedia {
  display: flex;
  width: 100%;
  margin: auto;
  justify-content: center;
}

.ibcText {
  margin-left: 0.5rem;
  font-size: 1.4rem;
  color: #003e7d;
  font-family: Optima, Segoe, Segoe UI, Candara, Calibri, Arial, sans-serif;
}
</style>
